<template lang="pug">
.v-ads-builder.ads-builder
	.ads-builder__container
		v-loader(:loading="loading")
		.ads-builder__left(v-if="data")
			.ads-builder__title
		.ads-builder__right(v-if="data")
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null,
				timerId: null,
				localFormData: new FormData(),
			}
		},

		methods: {
			dataSet(data) {
				this.data = data;
				this.setErrors();

			},

			proxyFieldName(name) {
				return `state[form][${name}]`;
			},

			setErrors() {
				if (this.data?.fields?.length) {
					this.data.fields.forEach((field) => {
						field.errors = this.getFieldError(field)
					})
				}
			},

			fileInput(field, e) {
				this.savedFileKeys = [];
				for (let i = 0; i < e.target.files.length; i++) {
					this.savedFileKeys.push(e.key);
					this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
				}

			},

			sendFormBuilder(action = null) {
				this.requestDataLoad(this.data.remote, action)
			},

			sentForm() {
				this.requestDataLoad(this.data.remote)
			},

			requestDataLoad(remote = this.data.remote, action = null) {
				clearTimeout(this.timerId);

				let namesOfCurrentIteration = [];
				if (this.data && this.data.fields) {
					this.data.fields.forEach(field => {
						let key = this.proxyFieldName(field.name);
						if (field.multiple) {
							key = this.proxyFieldName(field.name.replace('[]', ''));
						}
						if (!field.value) {
							field.value = '';
						}
						if (field.type === 'file') {
							// очистка полей для файлов от старых значений
							for (let item of this.localFormData.entries()) {
								let isfoundInSavedFileKeys = false;
								for (let j = 0; j < this.savedFileKeys.length; j++) {
									if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
										isfoundInSavedFileKeys = true;
										break;
									}
								}
								if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
									this.localFormData.delete(item[0]);
								}
							}
						}
						if (namesOfCurrentIteration.indexOf(key) < 0) {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}
						if (field.type === 'file') {
							// обработка файлов происходит в fileInput / fileRemove
							// здесь ничего делать не нужно
							/*
							 _.each(field.value, (fileListItem) => {
							 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
							 });
							 */
						} else {
							// для отправки файлов придется держать в памяти неизменный localFormData
							// перед отправкой нужно удалить старые значения из localFormData
							// т.к. localFormData.append добавляет новые значения к существующим
							// а localFormData.set не позволила бы работать с массивами типа NAME[]
							if (namesOfCurrentIteration.indexOf(key) < 0) {
								this.localFormData.delete(key);
								namesOfCurrentIteration.push(key);
							}
							if (Array.isArray(field.value)) {
								field.value.forEach((val, index) => {
									this.localFormData.append(`${key}[${index}]`, val);
								});
							} else {
								this.localFormData.append(key, field.value);
							}
						}
					});
				}
				this.localFormData.set('bxajaxid', this.bxajaxid);
				this.localFormData.set('action', action);

				this.timerId = setTimeout(() => {

					this.dataLoad({
						url: remote,
						delay: true,
						data: this.localFormData
					}, remote);
				},500)

			},

			getFieldError(field) {
				if (this.data.errors && this.data.errors.fields) {
					let filteredErrors = this.data.errors.fields.filter((item) => item.name === field.name);
					return filteredErrors.length ? filteredErrors : null;
				} else {
					return null;
				}
			},


		}

	}
</script>